// @ts-ignore
import { MemoryDoesNotExistError } from "@seneca/memory-service-client";

import getMessageFromError from "seneca-common/utils/functions/services/getMessageFromError";

export default function errorTranslator(error: Error): string {
  try {
    if (typeof error === "string") return error;

    if (error instanceof MemoryDoesNotExistError)
      return "Oh no! This memory does not exist!";

    return getMessageFromError(error) || "An unknown error has occurred.";
  } catch (err: any) {
    return "An unknown error has occurred.";
  }
}
